export interface Routes {
  [key: string]: string;
}

type Params = Record<string, string | number | boolean | undefined>;

export const buildRoute = (baseRoute: string, params: Params) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, String(value));
    }
  });

  return searchParams.toString()
    ? `${baseRoute}?${searchParams.toString()}`
    : baseRoute;
};

export const noEnvRoutes = {
  filterOrders: "orders",
  downloadPhoto: "photos/{imageId}/download-url",
  deletePhoto: "photos/{imageId}/delete",
};
